export enum LatencyKeys {
    base = 'base',
    today = 'today',
}
